import * as React from "react";
import { observer } from "mobx-react";
import { observable, action, computed } from "mobx";
import { IUser, IRole, IGroup, AccountStatus } from "../../model/ModelTypes";
import { TextField, Checkbox, SelectField } from "react-md";
import { isNullOrUndefined } from "util";
import { IInputValidator } from "../../utility/IInputValidator";
import _ = require("lodash");
export class UserDetailsFormModel {
    @observable roles: IRole[];
    @observable groups: IGroup[];
    @observable typedPassword: string;
    @observable typedConfirmPassword: string;
    @observable nameError: boolean;
    @observable usernameError: boolean;
    @observable passwordError: boolean;
    @observable emailError: boolean;
    @observable confirmPasswordError: boolean;
    @observable typedName: string;
    @observable typedUsername: string;
    @observable selectedRoleId: string = "";
    @observable selectedGroupId: string = "";
    @observable typedEmail: string;
    @observable selectedStatus: number;
    @observable isAdmin: boolean;
    @observable currentUser?: IUser;
    @computed get saveEnabled() {
        return !(this.nameError || this.usernameError || this.passwordError || this.confirmPasswordError
                || this.emailError);
    }
    @computed get selectedRole() {
        if (isNullOrUndefined(this.selectedRoleId) && this.selectedRoleId !== "") {
            return undefined;
        }
        return this.roles.find(item => item.id === this.selectedRoleId);
    }
    private validator: IInputValidator;
    private organisationCode: string;
    constructor(inputValidator: IInputValidator,
                groups: IGroup[], roles: IRole[], organisationCode: string) {
        this.organisationCode = organisationCode;
        this.groups = groups;
        this.roles = roles;
        this.validator = inputValidator;
        this.resetForm();
        
    }
    getUser(): IUser {
        let user: IUser = {
            accessToken: "",
            refreshToken: "",
            name: this.typedName,
            role: this.roles.find(item => item.id === this.selectedRoleId),
            groups: [
                this.groups.find(item => item.id === this.selectedGroupId)
            ],
            email: this.typedEmail,
            status: this.selectedStatus,
            is_admin: this.isAdmin,
            username: this.typedUsername,
            organisation: this.organisationCode,
            id: !isNullOrUndefined(this.currentUser) ? this.currentUser.id.toString() : ""
        };

        if (this.typedPassword !== "********") {
            user.password = this.typedPassword;
        }
        return user;
    }
    
    @action.bound
    setRoles(roles: IRole[]) {
        this.roles = roles;
    }
    @action.bound
    setGroups(groups: IGroup[]) {
        this.groups = groups;
    }
    @action.bound
    setOriginalUser(user?: IUser) {
        if (!_.isEqual(user, this.currentUser)) {
            this.resetForm();
        }
        this.currentUser = user;
        if (!isNullOrUndefined(user)) {
            this.resetForm();
            this.typedEmail = user.email;
            this.typedName = user.name;
            this.typedUsername = user.username.replace(`${this.organisationCode.toUpperCase()}-`, "");      
            if (!isNullOrUndefined(user.groups) && !isNullOrUndefined(user.groups[0])) {
                this.selectedGroupId = user.groups[0].id.toString();
            }      
            this.selectedRoleId = isNullOrUndefined(user.role.id) ? "" : user.role.id.toString();
            this.typedPassword = "********";
            this.typedConfirmPassword = "********";
            this.selectedStatus = user.status;
            this.isAdmin = user.is_admin;
        }

    }
    @action.bound
    onTextFieldChange(inputKey: string, value: string) {
        switch (inputKey) {
            case "username":
                this.typedUsername = value;
                this.usernameError = !this.validator.isValidUserName(value);
                break;
            case "password":
                this.typedPassword = value;
                this.passwordError = !this.validator.isValidPassword(value);
                break;
            case "confirmPassword":
                this.typedConfirmPassword = value;
                this.confirmPasswordError = !this.validator.isValidPassword(value) ||
                    value !== this.typedPassword;
                break;
            case "name":
                this.typedName = value;
                this.nameError = !this.validator.isValidName(value);
                break;
            case "email":
                this.typedEmail = value;
                if (
                    isNullOrUndefined(this.selectedRole) || 
                    isNullOrUndefined(this.selectedRole.emailOptional) || 
                    !this.selectedRole.emailOptional || 
                    this.selectedRole.emailOptional && value !== ""
                ) {
                    this.emailError = !this.validator.isValidEmail(value);
                } else {
                    this.emailError = false;
                }
                break;
            default:
                return;
        }
    }
    
    @action.bound
    resetForm() {
        this.typedEmail = "";
        this.typedName = "";
        this.typedUsername = "";
        this.isAdmin = false;
        this.selectedStatus = -1;
        this.selectedGroupId = "null";
        this.selectedRoleId = "null";
        this.typedConfirmPassword = "";
        this.typedPassword = "";
        this.nameError = false;
        this.usernameError = false;
        this.passwordError = false;
        this.confirmPasswordError = false;
        this.emailError = false;
    }
}
@observer class UserDetailsForm extends React.Component<{ model: UserDetailsFormModel }, {}> {

    render() {
        return (
            <div>
                <div>
                    <div className="inputContianer">

                        <TextField
                            id="nameInput"
                            helpText="Min. 3 Characters. Spaces are Allowed."
                            required={true}
                            className="stackableTextInputRight"
                            error={this.props.model.nameError}
                            fullWidth={false}
                            label="Name"
                            type="text"
                            onChange={(e) => this.props.model.onTextFieldChange("name", e.toString())}
                            value={this.props.model.typedName}
                        />

                        <TextField
                            id="usernameInput"
                            helpText="Min. 3 Characters. Only letters,numbers and underscore character"
                            required={true}
                            error={this.props.model.usernameError}
                            className="stackableTextInputLeft"
                            fullWidth={false}
                            label="Username"
                            type="text"
                            onChange={(e) => this.props.model.onTextFieldChange("username", e.toString())}
                            value={this.props.model.typedUsername}
                            disabled={!isNullOrUndefined(this.props.model.currentUser)}
                        />
                    </div>
                    <div className="inputContianer">

                        <SelectField
                            id="roles"
                            required={true}
                            menuItems={
                                this.props.model.roles.map(item => {
                                    return { label: item.name, value: item.id };
                                })
                            }
                            value={this.props.model.selectedRoleId}
                            label="Role"
                            helpText="Select your role."
                            className="stackableTextInputRight"
                            placeholder="Select Role"
                            onChange={(value) => this.props.model.selectedRoleId = value.toString()}
                        />

                        <SelectField
                            id="groups"
                            menuItems={
                                this.props.model.groups.map(item => {
                                    return { label: item.name, value: item.id };
                                })
                            }
                            value={this.props.model.selectedGroupId}
                            onChange={(value) => this.props.model.selectedGroupId = value.toString()}
                            helpText="Select your group"
                            required={true}
                            label="Group"
                            className="stackableTextInputLeft"
                            placeholder="Select Group"
                        />

                    </div>
                    <div className="inputContianer">

                        <TextField
                            id="passwordInput"
                            helpText="Min. 8 Characters. At least 1 uppercase letter, 1 lowercase letter and 1 number."
                            required={true}
                            className="stackableTextInputRight"
                            error={this.props.model.passwordError}
                            fullWidth={false}
                            label="Password"
                            type="password"
                            onChange={(e) => this.props.model.onTextFieldChange("password", e.toString())}
                            value={this.props.model.typedPassword}
                        />

                        <TextField
                            id="confirmPasswordInput"
                            className="stackableTextInputLeft"
                            helpText="Min. 8 Characters. At least 1 uppercase letter, 1 lowercase letter and 1 number."
                            fullWidth={false}
                            label="Confirm Password"
                            error={this.props.model.confirmPasswordError}
                            required={true}
                            type="password"
                            onChange={(e) => this.props.model.onTextFieldChange("confirmPassword", e.toString())}
                            value={this.props.model.typedConfirmPassword}
                        />

                    </div>
                    <div className="inputContianer">

                        <TextField
                            id="emailInput"
                            required={ 
                                !isNullOrUndefined(this.props.model.selectedRole)
                                && !isNullOrUndefined(this.props.model.selectedRole.emailOptional) ? 
                                !this.props.model.selectedRole.emailOptional : true 
                            }
                            helpText={ 
                                !isNullOrUndefined(this.props.model.selectedRole)
                                && !isNullOrUndefined(this.props.model.selectedRole.emailOptional) 
                                && this.props.model.selectedRole.emailOptional ?
                                "Email is optional for the selected role" : "Must be a valid email address."
                            }
                            className="stackableTextInputRight"
                            fullWidth={false}
                            error={this.props.model.emailError}
                            label="Email"
                            type="email"
                            onChange={(e) => this.props.model.onTextFieldChange("email", e.toString())}
                            value={this.props.model.typedEmail}
                            disabled={!isNullOrUndefined(this.props.model.currentUser)}
                        />
                        <SelectField
                            id="status"
                            menuItems={
                                [
                                    {
                                        label: "Approved", value: AccountStatus.approved
                                    },
                                    {
                                        label: "Requires Attention", value: AccountStatus.PendingAdminApproval
                                    }
                                ]
                            }
                            onChange={(value) => 
                                isNullOrUndefined(value) ? this.props.model.selectedStatus = -1 :
                                // tslint:disable-next-line:radix
                                this.props.model.selectedStatus = parseInt(value.toString())}
                            helpText="Select Account Status"
                            required={true}
                            label="Status"
                            value={this.props.model.selectedStatus}
                            className="stackableTextInputLeft"
                            placeholder="Select Account Status"
                        />

                    </div>

                    <Checkbox
                        label="Admin Access"
                        id="enableStatusCheckBox"
                        name="Admin Access"
                        checked={this.props.model.isAdmin}
                        onChange={(checked: boolean) => this.props.model.isAdmin = checked}
                    />
                </div>
            </div>

        );
    }
}
export default UserDetailsForm;


// WEBPACK FOOTER //
// ./src/component/UserDetailsForm/UserDetailsForm.tsx